import React from "react";
import { Feed } from "semantic-ui-react";
import PropTypes from "prop-types";
import { encodeUserUrl } from "../../helpers/userHelper";

const FriendItem = ({ _id, firstName, lastName, photo, clubs }, history) => {
  // <Feed.Extra images>
  // {clubs.map(c => {
  //   return (
  //     <a onClick={() => history.push(c.club.link)}>
  //       <img src={c.club.image} title={c.club.title} alt={c.club.title} />
  //     </a>
  //   )
  // })}
  // </Feed.Extra>
  return (
    <Feed.Event key={_id}>
      <Feed.Label image={photo} />
      <Feed.Content>
        <Feed.Summary>
          <a
            onClick={() =>
              history.push(encodeUserUrl(_id, firstName, lastName))
            }
          >{`${firstName} ${lastName}`}</a>
        </Feed.Summary>
      </Feed.Content>
    </Feed.Event>
  );
};

FriendItem.defaultProps = {
  history: {}
};

FriendItem.propTypes = {
  _id: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  photo: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  })
};

export default FriendItem;



// WEBPACK FOOTER //
// ./src/components/FriendsList/FriendItem.js